export default "__VITE_ASSET__OG1BTbkx__"